import _regeneratorRuntime from "/Users/mikefree/Desktop/strata-2019/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/mikefree/Desktop/strata-2019/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteral from "/Users/mikefree/Desktop/strata-2019/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["# Utilities"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["<form><button name=button>Click to transition elements"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# Delay transitions\nThis brief demo shows the use of data attributes in the <code>.delay()</code> method to achieve an animated transition based on the <code>x</code> position of each circle. Data from the <a href=\"https://archive.ics.uci.edu/ml/datasets/Breast+Cancer+Wisconsin+(Diagnostic)\" target=\"_blank\">Wisconsin Breast Cancer</a> dataset, as was used in this <a href=\"http://mfviz.com/binary-predictions/\" target=\"_blank\">visual explanation</a> of binary prediction performance metrics. \n\ntl;dr:\n\n<pre>\n<code lang=\"js\">\ncircles.transition()\n  .duration(500)\n  .delay((d) => xScale(d.x) / xScale.range()[1] * 500)\n</code>\n</pre>\n"], ["# Delay transitions\nThis brief demo shows the use of data attributes in the <code>.delay()</code> method to achieve an animated transition based on the <code>x</code> position of each circle. Data from the <a href=\"https://archive.ics.uci.edu/ml/datasets/Breast+Cancer+Wisconsin+(Diagnostic)\" target=\"_blank\">Wisconsin Breast Cancer</a> dataset, as was used in this <a href=\"http://mfviz.com/binary-predictions/\" target=\"_blank\">visual explanation</a> of binary prediction performance metrics. \\n\ntl;dr:\n\n<pre>\n<code lang=\"js\">\ncircles.transition()\n  .duration(500)\n  .delay((d) => xScale(d.x) / xScale.range()[1] * 500)\n</code>\n</pre>\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// URL: https://observablehq.com/@mkfreeman/delay-transitions
// Title: Delay transitions
// Author: Michael Freeman (@mkfreeman)
// Version: 412
// Runtime version: 1
var m0 = {
  id: "79acd42c7a4a2b22@412",
  variables: [{
    inputs: ["md"],
    value: function value(md) {
      return md(_templateObject());
    }
  }, {
    name: "viewof button",
    inputs: ["html", "chart"],
    value: function value(html, chart) {
      var form = html(_templateObject2());

      form.button.onclick = function (event) {
        event.preventDefault(); // Don’t submit the form.

        chart.update();
      };

      return form;
    }
  }, {
    name: "button",
    inputs: ["Generators", "viewof button"],
    value: function value(G, _) {
      return G.input(_);
    }
  }, {
    name: "chart",
    inputs: ["settings", "d3", "DOM", "data"],
    value: function value(settings, d3, DOM, data) {
      var fullWidth = settings.width + settings.margin.left + settings.margin.right,
          fullHeight = settings.height + settings.margin.top + settings.margin.bottom;
      var svg = d3.select(DOM.svg(fullWidth, fullHeight));
      var xScale = d3.scaleLinear().rangeRound([0, settings.width]).domain(d3.extent(data, function (d) {
        return +d.xValue;
      }));
      var yScale = d3.scaleLinear().rangeRound([settings.height, 0]).domain([-.05, 1]);
      var g = svg.append("g").attr("transform", "translate(" + settings.margin.left + "," + settings.margin.top + ")");
      svg.append("g").attr("class", "axis axis--x").attr("transform", "translate(" + settings.margin.left + "," + (settings.height + settings.margin.top) + ")").call(d3.axisBottom(xScale));
      svg.append("g").attr("class", "axis axis--y").attr("transform", "translate(" + settings.margin.left + "," + settings.margin.top + ")").call(d3.axisLeft(yScale));
      var circles = g.selectAll("circle").data(data);
      circles.enter().append("circle").attr("cx", function (d) {
        return xScale(d.xValue);
      }).attr("cy", function (d) {
        return yScale(0);
      }).attr("r", 10).attr("fill", function (d) {
        return d.color;
      }).style("opacity", .3);

      svg.node().update = function () {
        settings.position = settings.position == "base" ? "y" : "base";
        g.selectAll("circle").transition().duration(settings.delay).delay(function (d) {
          return xScale(d.xValue) / xScale.range()[1] * 500;
        }).attr("cx", function (d) {
          return xScale(d.xValue);
        }).attr("cy", function (d) {
          return settings.position == "y" ? yScale(d.yValue) : yScale(0);
        });
      };

      return svg.node();
    }
  }, {
    inputs: ["md"],
    value: function value(md) {
      return md(_templateObject3());
    }
  }, {
    name: "data",
    inputs: ["d3"],
    value: function () {
      var _value = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(d3) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return d3.csv("https://raw.githubusercontent.com/mkfreeman/binary-predictions/master/public/data/cancer_data.csv").then(function (data) {
                  data.forEach(function (d) {
                    d.xValue = +d.worst_concave_points, d.color = +d.outcome === 0 ? "blue" : "red", d.yValue = +d.logistic_preds;
                  });
                  return data;
                });

              case 2:
                _context.t0 = function (d) {
                  return d.xValue >= 0 & d.xValue < .4;
                };

                return _context.abrupt("return", _context.sent.filter(_context.t0));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function value(_x) {
        return _value.apply(this, arguments);
      }

      return value;
    }()
  }, {
    name: "settings",
    value: function value() {
      return {
        margin: {
          top: 50,
          right: 40,
          bottom: 50,
          left: 40
        },
        height: 500,
        width: 900,
        delay: 1000,
        position: "base"
      };
    }
  }, {
    name: "d3",
    inputs: ["require"],
    value: function value(require) {
      return require("d3@5");
    }
  }]
};
var notebook = {
  id: "79acd42c7a4a2b22@412",
  modules: [m0]
};
export default notebook;